import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["field", "panel", "value"]

  connect() {
    this.element.classList.add("is-enhanced")
    this.show()

    this._outside = event => { if (!this.element.contains(event.target)) this.close() }
    this._escape  = event => { if (event.key === "Escape") this.close() }
    document.addEventListener("click", this._outside)
    document.addEventListener("keydown", this._escape)
  }

  disconnect() {
    document.removeEventListener("click", this._outside)
    document.removeEventListener("keydown", this._escape)
  }

  toggle(event) {
    event.preventDefault()
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this._mark()
    this._place()
  }

  close() {
    this.panelTarget.hidden = true
  }

  pick(event) {
    event.preventDefault()
    this.fieldTarget.value = event.currentTarget.dataset.value
    // The select is the value: whoever listens to it must hear this too.
    this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.show()
    this.close()
  }

  // The select may also be set from elsewhere; the trigger follows it.
  show() {
    this.valueTarget.textContent = this.fieldTarget.value
    this._mark()
  }

  _place() {
    this.panelTarget.classList.remove("is-above")

    const panel = this.panelTarget.getBoundingClientRect()
    const room  = window.innerHeight - this.element.getBoundingClientRect().bottom

    if (panel.height + 8 > room) this.panelTarget.classList.add("is-above")
  }

  _mark() {
    this.panelTarget.querySelectorAll("[data-value]").forEach(cell => {
      cell.classList.toggle("is-selected", cell.dataset.value === this.fieldTarget.value)
    })
  }
}
